export default "__VITE_ASSET__a97bf5c6__"